import $ from 'jquery';
import AlerterView from 'chairisher/view/alerter';

import { getCertcaptureJSUrl } from 'chairisher/context/script';

function onError() {
    AlerterView.error();
}

// Prevents script from being included twice
const scriptId = 'js-certcapture-script';

export default (onLoadCallback) => {
    if ($(`#${scriptId}`).length === 0) {
        const script = document.createElement('script');
        script.src = getCertcaptureJSUrl();
        script.id = scriptId;
        script.onerror = onError;
        script.async = false;
        script.onload = () => {
            if (window.GenCert) {
                onLoadCallback(window.GenCert);
            } else {
                onError();
            }
        };
        document.head.appendChild(script);
    } else if (window.GenCert) {
        onLoadCallback(window.GenCert);
    }
};
